import styled from "styled-components";

import { media } from "../../styles/media";

export const AuthLayoutStyles = styled.section`
  display: flex;
  height: 100vh;
  background: ${({ theme }) => theme.colors.semantic.container.white};

  @keyframes contentFadeIn {
    from {
      opacity: 0;
      transform: translateY(8px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .formContainer {
    width: 50%;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    padding: 0 0 100px 0;
    position: relative;
    overflow-y: auto;
  }

  .contentWrapper {
    display: flex;
    align-items: center;
    flex-direction: column;
    opacity: 0;
    animation: contentFadeIn 0.3s cubic-bezier(0.4, 0, 0.2, 1) 0.35s forwards;
  }

  .termsText {
    position: absolute;
    bottom: 24px;
    font-weight: normal;
    color: #8e8e8e;
    font-size: 12px;
    text-align: center;
    /* Paragraph defaults to word-break: break-all, which splits "Privacy"
       mid-word ("Pr | ivacy"). Break on spaces instead so it wraps cleanly. */
    word-break: normal;
    overflow-wrap: break-word;
    opacity: 0;
    animation: contentFadeIn 0.3s cubic-bezier(0.4, 0, 0.2, 1) 0.5s forwards;
  }

  .imageContainer {
    width: 50%;
    height: 100%;
    padding: 16px;
    box-sizing: border-box;
    overflow: hidden;

    .loginImage {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 24px;
    }
  }

  /* On smaller screens drop the decorative image panel and give the form the
     full width. Anchor content to the top (not centered) so a tall form never
     pushes the logo off-screen, and let the terms line flow inline so it stays
     scrollable/reachable instead of being pinned off the bottom. */
  ${media.maxTablet`
    /* Let the document scroll as one smooth surface instead of trapping the
       form in a 100vh inner scroller. With static 100vh the page isn't taller
       than the viewport, so the first swipe only collapses the address bar
       (feels like it "stops"); 100dvh + body scroll makes it one gesture. */
    height: auto;
    min-height: 100vh;
    min-height: 100dvh;

    .formContainer {
      width: 100%;
      padding: 40px 20px;
      justify-content: flex-start;
      overflow-y: visible;
    }
    .imageContainer {
      display: none;
    }
    .termsText {
      position: static;
      bottom: auto;
      margin-top: 32px;
      width: 100%;
    }
  `}
`;
